export function setCookie (name, value, days?) {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '')  + expires + '; path=/';
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/set-cookie.ts